import { FC, useEffect, useContext, useLayoutEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import FooterText from "src/components/footerText";
import CaseFilter from "src/components/manufacturer/statistics";
import CaseVolume from "src/components/manufacturer/caseVolume";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { AuthContext } from "../../context/authContext";

import { ToastTypes } from "src/types";
import { GeographicalStatisticsObject, StatisticsApiResponse } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import AreasListing from "src/components/manufacturer/areasListing";
import { StatsContext } from "src/context/statsContext";




const Manufacturer: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const { state: queryParams, updateState: changeQueryParams } = useContext(StatsContext)

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);




  const { loading: isStatisticsAPILoading, error: statisticsApiError, data: statisticsData, mutate: getStatsData } = 
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, {}, {}, false);

  useLayoutEffect(() => setLoader(), [])


  useEffect(() => {
    if (statisticsData || statisticsApiError) {
      hideLoader();

      if (statisticsData) {
        if (statisticsData.code === 200) {
          showToast([statisticsData.message], ToastTypes.SUCCESS);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);




  useEffect(() => {
    if (isStatisticsAPILoading) return;

    const updatedState = {
      start_date: searchParams.get("start_date") || queryParams.start_date,
      end_date: searchParams.get("end_date") || queryParams.end_date,
      period: searchParams.get("period") || queryParams.period,
      filter_type: searchParams.get("filter") || queryParams.filter_type,
      type: "index",
      role: userData ? userData.ref_type.toLowerCase() : searchParams.get("role") || queryParams.role,
      soc_value: searchParams.get("soc_value") || queryParams.soc_value,
      drug_id: searchParams.get("drug_id") || queryParams.drug_id,
      id: "",
      insurance_name: params.get("insurance_name") || queryParams.insurance_name,
    };

    changeQueryParams(updatedState);
    setLoader();
    getStatsData({}, {}, updatedState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])





  const updateQueryParamsAndCallAPI = (updatedQueries: StatisticsSearchProps): void => {
    const updatedQuerie = {
      ...updatedQueries,
      role: userData ? userData.ref_type.toLowerCase() : searchParams.get("role") || queryParams.role,
    } 
    changeQueryParams(updatedQuerie);
    setLoader();
    getStatsData({}, {}, updatedQuerie);
  };

  const getStatisticsData = (period: string) => {
    const updatedQueries = {
      ...queryParams,
      role: userData ? userData.ref_type.toLowerCase() : searchParams.get("role") || queryParams.role,
      period,
    } 
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
    <div className="overflow-y-auto">
      <div className="container mb-3">
        {statisticsData && (
          <CaseFilter
            defaultQueryParams={queryParams}
            updateQueryParams={updateQueryParamsAndCallAPI}
          />
        )}

        {statisticsData && statisticsData.data && statisticsData.data.case_volume && (
          <CaseVolume isButtonPanelVisible={true} statsData={statisticsData.data} getStatisticsData={getStatisticsData} />
        )}

        {statisticsData && statisticsData.data && statisticsData.data.top_payors && (
          <div className="mt-3">
            <CustomPieChart pieChartObject={statisticsData.data.top_payors} title="Top 10 Payors" />
          </div>
        )}

        {statisticsData && statisticsData.data && (
          <div className="row my-3 gx-3 align-items-stretch">
            <div className="col-md-6 col-12">
              <AreasListing title="Areas" territories={statisticsData.data.territories} />
            </div>
            <div className="col-md-6 col-12">
              <CustomPieChart pieChartObject={statisticsData.data.mos} title="Cases By Submission Mode" />
            </div>
          </div>
        )}

        {statisticsData && statisticsData.data && statisticsData.data.geographical_stats && (
          <div className="my-3">
            <GeographicalStatistics
              GeographicalStatisticsListType={
                statisticsData?.data
                  .geographical_stats as unknown as GeographicalStatisticsObject[]
              }
            />
          </div>
        )}

        <div className="mt-3">
          <FooterText footerType="black" />
        </div>
      </div>
    </div>
  );
};

export default Manufacturer;
